{
  "comment": "stationExclusion (m) is measured from a station's hull, its bounding sphere: no raider or repo spawn, no director roll and no contract marker within R + stationExclusion of a station's centre (scale SC-5e1). spawnDistance and despawnDistance are from the player. bandScale (M10 P4b6a, hull tiers spec §2.5 and §4.5) scales a raid to the flown hull's size band: a band listed here draws its wave tierStep cargo tiers higher (capped at the top tier), and the first ship of that pack the kit fits flies it (the Harpoon on a gunship; no ship is added). Bands not listed raid as before. Values are [P].",
  "intervalSeconds": [480, 720],
  "baseChance": 0.4,
  "cargoValueScale": 35000,
  "maxChance": 0.9,
  "tiers": [
    { "minCargoValue": 0, "wave": 1 },
    { "minCargoValue": 8000, "wave": 2 },
    { "minCargoValue": 20000, "wave": 3 },
    { "minCargoValue": 40000, "wave": 4 }
  ],
  "spawnDistance": [2000, 2600],
  "stationExclusion": 2000,
  "despawnDistance": 25000,
  "maxGroups": 8,
  "repo": {
    "ships": [
      { "ship": "interceptor", "profile": "veteran" },
      { "ship": "gunship", "profile": "veteran" }
    ],
    "undockDelaySeconds": 20,
    "inSpaceWithinSeconds": 300
  },
  "contractTiers": [1, 2, 3],
  "bandScale": {
    "L": { "tierStep": 1, "kit": "harpoon" }
  }
}
